import { render, staticRenderFns } from "./tab-options.vue?vue&type=template&id=62a2a86a&scoped=true"
import script from "./tab-options.vue?vue&type=script&lang=ts"
export * from "./tab-options.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a2a86a",
  null
  
)

export default component.exports